// extracted by mini-css-extract-plugin
export default {"header":"Header-module__header"};